module.exports = __webpack_public_path__ + "static/media/courier-icon.337d92cc.svg";